import * as api from "../../../api/index";
import React, { useState } from "react";
import { KeyboardArrowLeft, StarRate } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";

import {
  ALERT,
  COUNTER,
  REMOVE_UNAPPROVED_TRANSLATORS,
} from "../../../constants/actionTypes";

import "./Profile.css";

const Profile = ({
  user,
  loading,
  setShowProfile,
  usersLength,
  counter,
  noFxn,
  admin,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [type, setType] = useState("");
  const [message, setMessage] = useState("");
  const [approving, setApproving] = useState(false);
  const [declining, setDeclining] = useState(false);
  const rating = user?.rating
    ? user?.rating.total_stars / user?.rating.total_rating
    : 0;

  const openModal = (type) => {
    setType(type);
    document.querySelector(".unapproved__details").open = true;
  };

  const closeModal = () => {
    document.querySelector(".unapproved__details").open = false;
    setType("");
  };

  const handleApprove = async () => {
    setApproving(true);

    try {
      await api.updateUser(user._id, {
        "membership.approved": true,
        "membership.applied": false,
      });
      await api.counter({ unapproved_translators: -1 });
      dispatch({
        type: COUNTER,
        payload: {
          ...counter,
          unapproved_translators: counter.unapproved_translators - 1,
        },
      });
      if (usersLength < 2) history.push("/admin/index");
      dispatch({ type: REMOVE_UNAPPROVED_TRANSLATORS, id: user._id });
    } catch (error) {
      console.log(error);
      if (error.response)
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: error.response.data.message,
            duration: 5000,
            display: true,
          },
        });
      else {
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: "An unexpected error occurred",
            duration: 5000,
            display: true,
          },
        });
      }
    } finally {
      setApproving(false);
    }
  };

  const handleDecline = async () => {
    setDeclining(true);

    try {
      await api.updateUser(user._id, {
        "membership.approved": false,
        "membership.applied": false,
        rejection_msg: { message, createdAt: new Date() },
      });
      await api.counter({ unapproved_translators: -1 });
      dispatch({
        type: COUNTER,
        payload: {
          ...counter,
          unapproved_translators: counter.unapproved_translators - 1,
        },
      });
      if (usersLength < 2) history.push("/admin/index");
      dispatch({ type: REMOVE_UNAPPROVED_TRANSLATORS, id: user._id });
    } catch (error) {
      if (error.response)
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: error.response.data.message,
            duration: 5000,
            display: true,
          },
        });
      else {
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: "An unexpected error occurred",
            duration: 5000,
            display: true,
          },
        });
      }
    } finally {
      setDeclining(false);
    }
  };

  const adminStyle = {
    position: "fixed",
    top: 0,
    right: 0,
    height: "100vh",
    width: "calc(100vw - 280px)",
    padding: "20px",
    zIndex: 4,
  };

  return (
    <>
      <div
        style={admin ? adminStyle : {}}
        className="profile d-flex flex-column pb-40 overflow-auto"
      >
        {admin && (
          <h2
            className="d-flex align-center mb-40 py-20 font-subhead pointer"
            onClick={() => setShowProfile(false)}
          >
            <KeyboardArrowLeft style={{ fontSize: "50px" }} />
            <span className="text-uppercase">{user?.name}</span>
          </h2>
        )}
        {loading ? (
          <div className="w-100 h-100 d-flex align-center justify-center">
            <div className="spin-large"></div>
          </div>
        ) : (
          <>
            {Object.keys(user).length < 1 ? (
              <h2 className="text-center">No User Found</h2>
            ) : (
              <div className="">
                <div>
                  <h3 className="profile__header px-40 pb-5">
                    Personal Information
                  </h3>
                  <div className="profile__top d-flex justify-between f-100">
                    <div className="profile__info d-flex flex-column rounded f-100">
                      <div className="profile__top__grid grid c-3">
                        <div className="d-flex flex-column p-20">
                          <span className="">Availability</span>
                          <span className="font-bold">{user.availability}</span>
                        </div>
                        <div className="d-flex flex-column p-20">
                          <span className="">Years of Experience</span>
                          <span className="font-bold">
                            {user.experience} Year
                            {user.experience > 1 ? "s" : ""}
                          </span>
                        </div>
                        <div className="d-flex flex-column p-20">
                          <span className="">Email</span>
                          <span className="font-bold">{user.email}</span>
                        </div>
                        <div className="d-flex flex-column p-20">
                          <span className="">Address</span>
                          <span className="font-bold">{user.address}</span>
                        </div>
                        <div className="d-flex flex-column p-20">
                          <span className="">City</span>
                          <span className="font-bold">{user.city}</span>
                        </div>
                        <div className="d-flex flex-column p-20">
                          <span className="">Country</span>
                          <span className="font-bold">{user.country}</span>
                        </div>
                      </div>
                    </div>
                    {!admin && (
                      <div className="d-flex flex-column align-end justify-end f-30">
                        <button
                          className="w-75 border-0 outline-0 p-10 font-bold rounded"
                          onClick={() => history.push("/translator/index")}
                        >
                          GO TO WORKPKACE
                        </button>
                      </div>
                    )}
                    {admin && !noFxn && (
                      <div className="d-flex flex-column align-end justify-end f-30">
                        <button
                          style={{ backgroundColor: "rgb(0, 172, 0)" }}
                          className="w-75 border-0 outline-0 p-10 font-bold rounded mb-20"
                          onClick={() => openModal("approve")}
                        >
                          APPROVE
                        </button>
                        <button
                          style={{ backgroundColor: "crimson" }}
                          className="w-75 border-0 outline-0 p-10 font-bold rounded"
                          onClick={() => openModal("decline")}
                        >
                          DECLINE
                        </button>
                      </div>
                    )}
                  </div>
                </div>
                <div className="mt-40">
                  <h3 className="profile__header px-40 pb-5">
                    Professional Information
                  </h3>
                  <div className="d-flex justify-between f-100">
                    <div className="profile__info d-flex flex-column rounded f-100">
                      <div className="profile__bottom__grid grid c-4">
                        <div className="d-flex flex-column p-20">
                          <span className="">Source Language</span>
                          <span className="font-bold">{user.source_lang}</span>
                        </div>
                        <div className="d-flex flex-column p-20">
                          <span className="">Target Language</span>
                          <span className="font-bold">{user.target_lang}</span>
                        </div>
                        <div className="d-flex flex-column p-20">
                          <span className="">Native of Target Language</span>
                          <span className="font-bold">{user.native}</span>
                        </div>
                        <div className="d-flex flex-column p-20">
                          <span className="">
                            Official Translator /<br />
                            Linguistic Degree
                          </span>
                          <span className="font-bold">{user.certified}</span>
                        </div>
                        <div className="d-flex flex-column p-20">
                          <span className="">Sworn Translator</span>
                          <span className="font-bold">{user.sworn}</span>
                        </div>
                        <div className="d-flex flex-column p-20">
                          <span className="">Total Words Translated</span>
                          <span className="font-bold">
                            {user.words_translated}
                          </span>
                        </div>
                        <div className="d-flex flex-column p-20">
                          <span className="">Experience</span>
                          <span className="font-bold">{user.experience}</span>
                        </div>
                        <div className="d-flex flex-column p-20">
                          <span className="">Completed Projects</span>
                          <span className="font-bold">
                            {user.completedProjects}
                          </span>
                        </div>
                        <div className="d-flex flex-column p-20">
                          <span className="">Services</span>
                          <span className="font-bold">
                            {user?.services?.join(", ")}
                          </span>
                        </div>
                        <div className="d-flex flex-column p-20">
                          <span className="">Other Services</span>
                          <span className="font-bold">
                            {user.other_services ? user.other_services : "None"}
                          </span>
                        </div>
                        <div className="d-flex flex-column p-20">
                          <span className="">Tools</span>
                          <span className="font-bold">
                            {user?.tools?.join(", ")}
                          </span>
                        </div>
                        <div className="d-flex flex-column p-20">
                          <span className="">Other Tools</span>
                          <span className="font-bold">
                            {user.other_tools ? user.other_tools : "None"}
                          </span>
                        </div>
                        {admin && (
                          <>
                            <div className="d-flex flex-column p-20">
                              <span className="">Expertise</span>
                              <span className="font-bold">
                                {user?.expertise?.join(", ")}
                              </span>
                            </div>
                            <div className="d-flex flex-column p-20">
                              <span className="">Other Expertise</span>
                              <span className="font-bold">
                                {user.other_expertise
                                  ? user.other_expertise
                                  : "None"}
                              </span>
                            </div>
                            <div className="d-flex flex-column p-20">
                              <span className="">Bio</span>
                              <span className="font-bold">{user.bio}</span>
                            </div>
                            <div className="d-flex flex-column p-20">
                              <span className="">Rating</span>
                              <div className="d-flex">
                                <StarRate
                                  style={{
                                    color:
                                      rating > 0.49
                                        ? "rgb(0, 172, 0)"
                                        : "lightgray",
                                  }}
                                />
                                <StarRate
                                  style={{
                                    color:
                                      rating > 1.49
                                        ? "rgb(0, 172, 0)"
                                        : "lightgray",
                                  }}
                                />
                                <StarRate
                                  style={{
                                    color:
                                      rating > 2.49
                                        ? "rgb(0, 172, 0)"
                                        : "lightgray",
                                  }}
                                />
                                <StarRate
                                  style={{
                                    color:
                                      rating > 3.49
                                        ? "rgb(0, 172, 0)"
                                        : "lightgray",
                                  }}
                                />
                                <StarRate
                                  style={{
                                    color:
                                      rating > 4.49
                                        ? "rgb(0, 172, 0)"
                                        : "lightgray",
                                  }}
                                />
                              </div>
                            </div>
                          </>
                        )}
                        <div className="d-flex flex-column p-20">
                          <span className="">Payment Details</span>
                          <span className="font-bold">{user.payment}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>
      <details className="unapproved__details">
        <summary className="list-none"></summary>
        <div className="d-flex align-center justify-center position-fixed t-0 r-0 w-100 h-100 z-5">
          <div className="d-flex flex-column align-center text-center p-20">
            {
              <h3 className="font-subhead">
                {type === "approve" ? "Approve" : "Decline"} Translator
              </h3>
            }
            {type === "approve" && (
              <p className="font-heavy font-big py-40">
                You are are approving {user.name}, {user.source_lang} to{" "}
                {user.target_lang} Translator as a OneConverse Translator
              </p>
            )}
            {type === "decline" && (
              <div>
                <p className="font-heavy font-big py-10">
                  Input reason for declining
                </p>
                <textarea
                  className="mt-10 mb-40 w-100 border-0 outline-0 p-10 border-1 box-shadow-lg"
                  placeholder="..."
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
              </div>
            )}
            <div className="d-flex justify-between">
              <button
                className="unapproved__btn__cancel border-0 outline-0 p-10 font-normal font-bold w-45 rounded"
                onClick={closeModal}
              >
                Cancel
              </button>
              {type === "approve" && (
                <button
                  style={{ opacity: user === {} ? "0.6" : "" }}
                  className="unapproved__btn__aprrove d-flex justify-center align-center border-0 outline-0 p-10 font-normal font-bold w-45 rounded"
                  onClick={handleApprove}
                  disabled={user === {}}
                >
                  Approve
                  {approving && <div className="spin-white ml-10"></div>}
                </button>
              )}
              {type === "decline" && (
                <button
                  style={{
                    opacity: message === "" || user === {} ? "0.6" : "",
                  }}
                  className="unapproved__btn__decline d-flex justify-center align-center border-0 outline-0 p-10 font-normal font-bold w-45 rounded"
                  onClick={handleDecline}
                  disabled={message === "" || user === {}}
                >
                  Decline
                  {declining && <div className="spin-white ml-10"></div>}
                </button>
              )}
            </div>
          </div>
        </div>
      </details>
    </>
  );
};

export default Profile;
